import { useNuxtApp } from '#app/nuxt';
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css'

import 'element-plus/es/components/message/style/css'

import { useCookie } from '#app/composables/cookie';
import useHttp from '/app/web-common-shared-components/hooks/auto-import-unique/useHttp.ts';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from "vue";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-549ae7f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "calculator" };
const _hoisted_2 = { class: "calculator-body" };
const _hoisted_3 = { class: "calculator-input" };
const _hoisted_4 = { class: "calculator-area-default" };
const _hoisted_5 = { class: "calculator-area-ul" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "calculator-area-title" };
const _hoisted_8 = { class: "calculator-keyboard" };
import { inputLatex } from "../utils";
import { KEY_BASIC, KEY_MORE_LIST } from "../type/constants";
import Additional from "./Additional.vue";
import KeyboardItem from "./KeyboardItem.vue";
import Result from "./Result.vue";
export default /* @__PURE__ */ _defineComponent({
  __name: "Calculator",
  props: {
    latex: {
      type: String
    }
  },
  setup(__props) {
    const { $addZSEvent } = useNuxtApp();
    let MQ;
    let mathField;
    const props = __props;
    const renderText = ref();
    const activeId = ref(1);
    const result = ref({});
    const calResult = ref({});
    const calInput = ref("");
    const handleClickUlItem = (changeId) => {
      activeId.value = changeId;
    };
    const handleClickKeyboard = (key) => {
      inputLatex(mathField, key);
    };
    const resultRef = ref();
    const goResult = () => {
      resultRef.value.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    };
    const submit = async () => {
      $addZSEvent("HOK_001");
      const latex = mathField.latex();
      if (!latex) {
        ElMessage({
          message: "not empty",
          type: "error"
        });
        return;
      }
      const latex_formula = latex.replace(/(.*?\^)(\d)/g, "$1{$2}");
      calInput.value = latex_formula;
      await getResult(latex_formula);
      goResult();
    };
    const getResult = async (latex_formula) => {
      var _a;
      const msgCategory = "214";
      const langCookie = useCookie("question-ai-lang");
      const formData = new FormData();
      formData.append("msgCategory", msgCategory);
      formData.append("latexFormula", latex_formula.replace("/\\%/", "%"));
      formData.append("appId", "aihomework");
      formData.append("clientType", "1");
      formData.append("type", "1");
      formData.append("cuid", useCookie("QUESTION_AI_PCUID").value || "");
      formData.append("lang", langCookie.value || "en");
      try {
        const res = await useHttp({
          url: "/questionai/chat/calculator",
          method: "POST",
          body: formData
        });
        const data = res._data.data;
        const item = (_a = data == null ? void 0 : data.stepResult) == null ? void 0 : _a.slice(-1);
        data.finalResult = item[0] ? item[0].formula : (data == null ? void 0 : data.valueResult) || (data == null ? void 0 : data.finalResult) || "";
        calResult.value = data;
      } catch (err) {
        console.log(err);
      }
    };
    onMounted(() => {
      if (window && window.MathQuill) {
        MQ = window.MathQuill.getInterface(2);
        mathField = MQ.MathField(renderText.value, {
          restrictMismatchedBrackets: true,
          spaceBehavesLikeTab: true,
          sumStartsWithNEquals: true,
          supSubsRequireOperand: true,
          charsThatBreakOutOfSupSub: "+-=<>",
          autoCommands: "pi theta sqrt sum",
          autoOperatorNames: "sin cos",
          maxDepth: 10,
          handlers: {
            edit: function() {
              console.log(mathField.latex());
            },
            enter() {
              const latex = mathField.latex();
              console.log("enter pressed", latex);
              submit();
            }
          }
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  id: "calculator-input-textarea",
                  ref_key: "renderText",
                  ref: renderText,
                  class: "calculator-input-textarea"
                }, null, 512),
                _createElementVNode("button", {
                  class: "calculator-solve",
                  onClick: submit
                }, "Solve")
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(KEY_MORE_LIST), (item) => {
                    return _openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: _normalizeClass([
                        "calculator-area-ul-li",
                        {
                          active: _unref(activeId) === item.id
                        }
                      ]),
                      onClick: ($event) => handleClickUlItem(item.id)
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
                    ], 10, _hoisted_6);
                  }), 128))
                ]),
                _createVNode(Additional, {
                  id: _unref(activeId),
                  "math-field": _unref(mathField)
                }, null, 8, ["id", "math-field"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(KEY_BASIC), (item) => {
                  return _openBlock(), _createBlock(KeyboardItem, {
                    key: item.key,
                    keyboard: item,
                    onPressKey: handleClickKeyboard
                  }, null, 8, ["keyboard"]);
                }), 128))
              ])
            ])
          ])
        ]),
        _unref(calInput) !== "" ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          ref_key: "resultRef",
          ref: resultRef
        }, [
          _createVNode(Result, {
            MQ: _unref(MQ),
            input: _unref(calInput),
            result: _unref(calResult)
          }, null, 8, ["MQ", "input", "result"])
        ], 512)) : _createCommentVNode("", true)
      ], 64);
    };
  }
});
